import { createContext, useContext } from 'react';
export var ReadonlyNetworksContext = createContext({
  providers: {},
  updateNetworkState: function updateNetworkState() {
    return undefined;
  },
  networkStates: {}
});
export function useReadonlyNetworks() {
  return useContext(ReadonlyNetworksContext).providers;
}
export function useUpdateNetworksState() {
  return useContext(ReadonlyNetworksContext).updateNetworkState;
}
export function useReadonlyNetworkStates() {
  return useContext(ReadonlyNetworksContext).networkStates;
}